import clsx from 'clsx';

const dividerStyle = (className) => clsx('flex items-center justify-center w-full h-px bg-gray-100', className);
var DividerStyles = {
    dividerStyle,
};

export { DividerStyles as default };
